import { useState, useEffect, useRef } from "react";
import { composeFullPhoneNumber, isPhoneNumberValid, parseStoredPhoneNumber } from "../_services/phone-utils";

const usePhoneNumber = (initialPhoneNumber = "", defaultCountryCode = "+49") => {
    const [phoneCountryCode, setPhoneCountryCode] = useState(defaultCountryCode);
    const [phoneLocal, setPhoneLocal] = useState("");
    const isInitialized = useRef(false);

    useEffect(() => {
        isInitialized.current = false;
    }, [initialPhoneNumber]);

    useEffect(() => {
        if (isInitialized.current) {
            return;
        }

        const fullPhoneNumber = initialPhoneNumber || "";

        if (!fullPhoneNumber) {
            setPhoneCountryCode(defaultCountryCode);
            setPhoneLocal("");
            isInitialized.current = true;
            return;
        }

        const phoneNumber = parseStoredPhoneNumber(fullPhoneNumber);

        if (phoneNumber) {
            setPhoneCountryCode("+" + phoneNumber.countryCallingCode);
            setPhoneLocal(phoneNumber.nationalNumber);
            isInitialized.current = true;
            return;
        }

        // Fallback: preserve digits if parsing fails
        setPhoneCountryCode(defaultCountryCode);
        setPhoneLocal(fullPhoneNumber.replace(/\D/g, ""));
        isInitialized.current = true;
    }, [initialPhoneNumber, defaultCountryCode]);

    const getFullPhoneNumber = () => composeFullPhoneNumber(phoneCountryCode, phoneLocal);

    // True when the entered number is valid for the selected country (empty counts as valid;
    // required-ness is enforced separately by the consuming form).
    const phoneNumberValid = isPhoneNumberValid(phoneCountryCode, phoneLocal);

    return {
        phoneCountryCode,
        phoneLocal,
        setPhoneCountryCode,
        setPhoneLocal,
        getFullPhoneNumber,
        phoneNumberValid,
    };
};

export default usePhoneNumber;
